<div *transloco="let t">
	<ng-container>
		<div class="flex flex-col">
			<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
				{{ t((isEdit() ? 'billing.parameterValue.change' : 'billing.parameterValue.newUse') + currentParameterType.toUpperCase()) }}
			</h2>
			<mat-dialog-content [formGroup]="parameterFg" class="flex flex-col">
				<div class="font-light text-xs text-gray-500 flex flex-row justify-between items-start">
					<div class="flex flex-col">
						<div>
							<p>{{ t('billing.selectedTu') }}: {{ selectedInstance()?.number }} / {{ selectedInstance()?.subNumber }}</p>
						</div>
						<div>
							<h2>{{ t('billing.selectedTuExpl') }}</h2>
						</div>
					</div>
					<div class="flex justify-center items-center mb-2 space-x-4">
						<button
							type="button"
							mat-icon-button
							[disabled]="currentInstanceIndex() === 0"
							(click)="selectPreviousInstance()"
							[matTooltip]="t('billing.prevInstance')">
							<mat-icon>keyboard_double_arrow_left</mat-icon>
						</button>

						<button
							type="button"
							mat-icon-button
							[disabled]="currentInstanceIndex() === currentInstances().length - 1"
							(click)="selectNextInstance()"
							[matTooltip]="t('billing.nextInstance')">
							<mat-icon>keyboard_double_arrow_right</mat-icon>
						</button>
					</div>
				</div>
				<div class="flex items-center justify-start w-full">
					<div class="text-black pr-2">{{ t('billing.superiorParameter') }}</div>
					<hr class="flex-1 my-4" />
				</div>
				@if (parameters()?.length) {
					<div class="flex flex-row justify-start items-start pt-2">
						<mat-form-field appearance="outline" class="mx-2 w-96">
							<mat-label>{{ t('billing.parameter') }}</mat-label>

							<mat-select formControlName="parameter" panelClass="wide-select-panel" (selectionChange)="loadParameter($event.value.type)">
								<mat-select-trigger>
									{{ getSelectedParameterName() }}
								</mat-select-trigger>
								@for (parameter of parameters(); track parameter.id) {
									<mat-option [value]="parameter">
										<div class="font-bold">
											{{ parameter?.name }}
										</div>
										<div class="font-light">
											{{ dateUtil.setDateFormatByActiveLang(parameter.validFrom, '') }}
											- {{ dateUtil.setDateFormatByActiveLang(parameter.validTo, t('common.today')) }}
										</div>
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						@if (isUserRelated() && currentInstanceUsers()?.length) {
							<mat-form-field appearance="outline" class="ml-4 w-80 h-">
								<mat-label>{{ t('billing.user') }}</mat-label>
								<mat-select formControlName="user">
									<mat-select-trigger>
										{{ getSelectedUserName() }}
									</mat-select-trigger>
									@for (user of currentInstanceUsers(); track user.exportId) {
										<mat-option [value]="user">
											<div class="font-bold">
												{{ user?.name }}
											</div>
											<div class="font-light">
												{{ user?.userRole.name }}
												{{ getUserDatesString(user) }}
											</div>
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						}
					</div>
					<div [@slideAnimation]="animationState" (@slideAnimation.done)="onAnimationDone()">
						<div class="p-2">
							<div class="flex items-center justify-start w-full">
								<div class="text-black pr-2">
									{{ t('billing.parameterValue.' + currentParameterType.toUpperCase()) }}
									&ndash; {{ t('billing.parameterValue.use') }}
								</div>
								<hr class="flex-1 my-4" />
							</div>
							<div class="text-sm">
								{{ t('billing.parameterValue.validityDateRange') }}
								@if (!parameterFg.get('parameter').value?.validFrom) {
									&ndash;
								} @else {
									{{ dateUtil.setDateFormatByActiveLang(parameterFg.get('parameter').value.validFrom, '') }} &ndash;
									{{ dateUtil.setDateFormatByActiveLang(parameterFg.get('parameter').value.validTo, t('common.today')) }}
								}
							</div>
						</div>
						<!-- Zeile 1: Wert -->
						@if (hasValue()) {
							<div class="flex flex-row items-center pt-3">
								<mat-form-field class="mx-2 w-96" appearance="outline">
									<mat-label>{{ t('common.value') }}</mat-label>
									<input matInput formControlName="value" araDecimalFormat />
									<span matSuffix class="mx-2 text-xl">{{ getValueUnitLabel() }}</span>
								</mat-form-field>
							</div>
						}
						@if (hasOptionValue()) {
							<div class="flex flex-row items-center pt-3">
								<mat-form-field appearance="outline" class="mx-2 w-96">
									<mat-label>{{ t('common.value') }}</mat-label>
									<mat-select formControlName="value">
										<mat-select-trigger>
											{{ t('tenantUnitSettingValue.' + this.parameterFg.get('value')?.value) }}
										</mat-select-trigger>
										@for (selectedValue of selectableValues(); track selectedValue) {
											<mat-option [value]="selectedValue">
												<div class="font-bold">
													{{ t('common.' + selectedValue.toLowerCase()) }}
												</div>
												<div class="font-light">
													{{ t('tenantUnitSettingValue.' + selectedValue) }}
												</div>
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
						}
						<!-- Zeile 2: validFrom / validTo (Today-Buttons entfernt) -->
						<div class="flex flex-row items-center pt-3">
							<mat-form-field [ngClass]="!isMobile ? 'mb-4 mx-2' : 'mb-1 w-full'" appearance="outline">
								<mat-label>{{ t('billing.parameterValue.usableFrom') }}</mat-label>
								<input
									formControlName="validFrom"
									[matDatepicker]="dpFrom"
									[min]="lockPortalAccessUntil?.add(1, 'day').isAfter(minDate) ? lockPortalAccessUntil.add(1, 'day') : minDate"
									[max]="maxDate"
									matInput />
								@if (parameterFg.errors?.message === 'errors.lockPortalAccessUntil') {
									<mat-error>
										{{
											t('tenantunitDetails.rolesView.lockDataChangeBefore', {
												lockDate: this.dateUtil.formatDate(lockPortalAccessUntil.add(1, 'day'), false),
											})
										}}
									</mat-error>
								} @else {
									<mat-error>{{ t('errors.checkInput') }}</mat-error>
								}
								<div matSuffix class="flex items-center">
									@if (parameterFg.get('validFrom')?.value && !parameterFg.get('validFrom')?.disabled) {
										<mat-datepicker-toggle>
											<mat-icon
												matDatepickerToggleIcon
												(click)="parameterFg.get('validFrom').setValue(undefined)"
												(keydown.enter)="parameterFg.get('validFrom').setValue(undefined)">
												clear
											</mat-icon>
										</mat-datepicker-toggle>
									}
									<mat-datepicker-toggle [for]="dpFrom" matSuffix></mat-datepicker-toggle>
								</div>
								<mat-datepicker #dpFrom></mat-datepicker>
							</mat-form-field>
							<mat-form-field [ngClass]="!isMobile ? 'mb-4 mx-2' : 'mb-1 w-full'" appearance="outline">
								<mat-label>{{ t('billing.parameterValue.usableTo') }}</mat-label>
								<input
									formControlName="validTo"
									[matDatepicker]="dpTo"
									[max]="maxDate"
									[min]="lockPortalAccessUntil?.isAfter(minDate) ? lockPortalAccessUntil : minDate"
									matInput />
								@if (parameterFg.errors?.message === 'errors.lockPortalAccessUntil') {
									<mat-error>
										{{
											t('tenantunitDetails.rolesView.lockDataChangeBefore', {
												lockDate: this.dateUtil.formatDate(lockPortalAccessUntil, false),
											})
										}}
									</mat-error>
								} @else {
									<mat-error>{{ t('errors.checkInput') }}</mat-error>
								}
								<div matSuffix class="flex items-center">
									@if (parameterFg.get('validTo')?.value && !parameterFg.get('validTo')?.disabled) {
										<mat-datepicker-toggle>
											<mat-icon
												matDatepickerToggleIcon
												(click)="parameterFg.get('validTo').setValue(undefined)"
												(keydown.enter)="parameterFg.get('validTo').setValue(undefined)">
												clear
											</mat-icon>
										</mat-datepicker-toggle>
									}
									<mat-datepicker-toggle [for]="dpTo" matSuffix></mat-datepicker-toggle>
								</div>
								<mat-datepicker #dpTo></mat-datepicker>
							</mat-form-field>
						</div>
						@if (parameterFg.invalid && parameterFg.errors?.message !== 'errors.lockPortalAccessUntil') {
							<div class="mx-2">{{ t(parameterFg.errors?.message) }}</div>
						}
					</div>
				} @else {
					{{ t('billing.warnParametersMissing') }}
				}
			</mat-dialog-content>
			<mat-dialog-actions mat-dialog-actions>
				<div class="flex flex-row justify-between items-center w-full">
					<div>
						@if (this.parameterValueId()) {
							<button (click)="confirmDelete()" [disabled]="parameterFg.get('value').disabled" mat-raised-button type="button">
								<mat-icon>delete</mat-icon>
								@if (!layoutService.isMobile()) {
									{{ t('commonActions.delete') }}
								}
							</button>
						}
					</div>
					<div class="flex flex-row justify-end items-center">
						<button (click)="close(false)" mat-raised-button type="button">
							<mat-icon>cancel</mat-icon>
							@if (!layoutService.isMobile()) {
								{{ t('commonActions.cancel') }}
							}
						</button>
						<button
							(click)="close(true, false)"
							color="primary"
							mat-raised-button
							[disabled]="!parameters()?.length || !parameterFg.valid || !parameterSelected()"
							type="submit">
							<mat-icon>check</mat-icon>
							@if (!layoutService.isMobile()) {
								{{ t('common.apply') }}
							}
						</button>
						<button
							(click)="close(true)"
							color="primary"
							mat-raised-button
							[disabled]="!parameters()?.length || !parameterFg.valid || !parameterSelected()"
							type="submit">
							<mat-icon>check</mat-icon>
							@if (!layoutService.isMobile()) {
								{{ t('common.applyAndClose') }}
							}
						</button>
					</div>
				</div>
			</mat-dialog-actions>
		</div>
	</ng-container>
</div>
